<template>
  <div class="app-container">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick" class="cardTabs">
      <el-tab-pane label="日请假一览" name="daily">
        <daily ref="daily"></daily>
      </el-tab-pane>
      <el-tab-pane label="请假汇总" name="total">
        <total ref="total"></total>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import daily from "@/components/at/leave/daily";
import total from "@/components/at/leave/total";

export default {
  name: "atleave",
  components: {
    daily,
    total,
  },
  data() {
    return {
      term_api: require("@/api/ed/term").default,
      tabName: "daily",
      isMB: this.$store.state.isMB,
      now_term: null,
    };
  },
  mounted() {
    this.term_api.list().then((res) => {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      if (res.Data.length > 0) {
        var term_id = loginInfo.TermId;
        if (!term_id) {
          this.now_term = res.Data[0];
        } else {
          this.now_term = res.Data.find((x) => x.TermId == loginInfo.TermId);
        }
        console.log("now_term", this.now_term);
      }
      this.reload();
    });
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      this.$refs[this.tabName].setTerm(this.now_term);
      this.$refs[this.tabName].getData();
    },
  },
};
</script>